import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"

const NextStatus = () => {
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const [nextStatus, setNextStatus] = useState<any>("")
    useEffect(() => {
        if(agentObj) {
            let agentSnapshot = agentObj?.toSnapshot();
            let nextStatus = agentSnapshot?.agentData?.snapshot?.nextState?.name
            setNextStatus(nextStatus)

            agentObj.onRefresh(()=>{
                let agentSnapshot = agentObj?.toSnapshot();
                let nextStatus = agentSnapshot?.agentData?.snapshot?.nextState?.name
                setNextStatus(nextStatus)
            })
        }
    },[agentObj])

    return (
        <React.Fragment>
            {nextStatus && 
                <div className="next-status">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">Next status <span className="ongoing-time ms-5">{nextStatus}</span></p>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}
export default NextStatus